import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Btn, Spinner } from '../../../../AbstractElements';
import { Card, CardBody, Col, Table, Form, FormGroup, Label, Row, CardHeader } from 'reactstrap';
import axios from 'axios';
import config from '../../../../config';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';

const ALL_COLUMNS = [
    { key: 'tenant_store_name', label: 'Tenant Name' },
    { key: 'group_name', label: 'Group Name' },
    { key: 'tenant_code', label: 'Tenant Code' },
    { key: 'outlet_code', label: 'Unit Code' },
    { key: 'property_name', label: 'Property' },
    { key: 'subcategory_name', label: 'Subcategory' },
    { key: 'floor', label: 'Floor' },
    { key: 'transaction_date', label: 'Date' },
    { key: 'invoice_no', label: 'Invoice No' },
    { key: 'transaction_time', label: 'Transaction Time' },
    { key: 'shift', label: 'Shift' },
    { key: 'sku', label: 'SKU' },
    { key: 'item_name', label: 'Item Name' },
    { key: 'currency', label: 'Currency' },
    { key: 'item_quantity', label: 'Qty' },
    { key: 'item_unit_price', label: 'Unit Price', isMoney: true },
    { key: 'item_discount', label: 'Discount', isMoney: true },
    { key: 'item_total_price', label: 'Item Total', isMoney: true },
    { key: 'item_tax_amount', label: 'Item Tax Amount', isMoney: true },
    { key: 'item_netsale_without_vat', label: 'Item Net Sale', isMoney: true },
    { key: 'item_gross_amount', label: 'Item Gross Amount', isMoney: true },
    { key: 'product_category1', label: 'Product Category 1' },
    { key: 'product_category2', label: 'Product Category 2' },
    { key: 'product_category3', label: 'Product Category 3' },
    //{ key: 'payment_details', label: 'Payment Details' },
];

const DEFAULT_COLUMNS = [
    'tenant_store_name',
    'group_name',
    'tenant_code',
    'outlet_code',
    'property_name',
    'floor',
    'transaction_date',
    'invoice_no',
    'transaction_time',
    'sku',
    'item_name',
    'item_quantity',
    'item_unit_price',
    'item_discount',
    'item_total_price',
    'item_tax_amount',
    'item_netsale_without_vat',
    'item_gross_amount',
];
const ItemwiseReportView = () => {

    if (localStorage.getItem("accessReports") !== "1") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const getYesterdayDate = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    };

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [propertyAccessNames, setPropertyAccesssNames] = useState('');
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const [startDate, setStartDate] = useState(getYesterdayDate());
    const [endDate, setEndDate] = useState(getYesterdayDate());
    const [properties, setProperties] = useState([]);
    const [categories, setCategories] = useState([]);
    const [group_name, setGroupName] = useState('');
    const [groups, setGroups] = useState([]);
    const [allSubcategories, setAllSubcategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [allTenants, setAllTenants] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [allFloors, setAllFloors] = useState([]);
    const [floors, setFloors] = useState([]);
    const [property_id, setPropertyId] = useState('');
    const [category_id, setCategoryId] = useState('');
    const [subcategory_id, setSubcategoryId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [selectedFloor, setSelectedFloor] = useState('');
    const [ReportData, setReportData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(50);
    const [validationMessage, setValidationMessage] = useState('');
    const [loading, setLoading] = useState(false)
    const today = new Date().toISOString().split('T')[0];
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const [tooltip, setTooltip] = useState('');

    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');

    const [selectedTenants, setSelectedTenants] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const dropdownRef = useRef(null);
    const [searchTenant, setSearchTenant] = useState('');

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const [selectedColumns, setSelectedColumns] = useState(DEFAULT_COLUMNS);
    const [columnDropdownOpen, setColumnDropdownOpen] = useState(false);
    const columnDropdownRef = useRef(null);

    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    // const getPaymentColumns = (data) => {
    //   const methodKeys = new Set();
    //   const amountKeys = new Set();

    //   data.forEach(row => {
    //     Object.keys(row).forEach(k => {
    //       if (k.startsWith('payment_method_')) methodKeys.add(k);
    //       if (k.startsWith('payment_amount_')) amountKeys.add(k);
    //     });
    //   });

    //   const sortedMethods = [...methodKeys].sort();
    //   const sortedAmounts = [...amountKeys].sort();

    //   return sortedMethods.flatMap((m, i) => ([
    //     { key: m, label: `Payment Method ${i + 1}` },
    //     { key: sortedAmounts[i], label: `Payment Amount ${i + 1}`, isMoney: true }
    //   ]));
    // };

    // 🔽 Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {

            // Tenant dropdown
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setDropdownOpen(false);
            }

            // Column dropdown
            if (
                columnDropdownRef.current &&
                !columnDropdownRef.current.contains(event.target)
            ) {
                setColumnDropdownOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);
                const propertyNames = response.data.map(property => property.property_name).join(',');
                setPropertyAccesssNames(propertyNames);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getgroupnames`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setGroups(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/category/getcategorybyconcessionaire`, { category_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setCategories(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        axios
            .post(`${config.hostname}/subcategory/getsubcategorybyconcessionaire`, { subcategory_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setAllSubcategories(response.data);
                setSubcategories(response.data); // Initial set to all subcategories
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        let filteredSubcategories = allSubcategories;

        if (category_id !== '') {
            filteredSubcategories = filteredSubcategories.filter(subcategory => subcategory.category_id._id === category_id);
        }

        setSubcategories(filteredSubcategories);
    }, [category_id]);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getenantsbyconcessionaire`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllTenants(response.data);
                setTenants(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredTenants = allTenants;

        if (group_name !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.group_name === group_name);
        }

        if (category_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_category_id._id === category_id);
        }

        if (property_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_property_id._id === property_id);
        }

        if (subcategory_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_subcategory_id._id === subcategory_id);
        }

        setTenants(filteredTenants);
    }, [group_name, property_id, category_id, subcategory_id, allTenants]);



    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getfloorsbyconcessionaire`, { concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllFloors(response.data);
                setFloors(getUniqueFloors(response.data));
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredFloors = allFloors;

        if (property_id !== '') {
            filteredFloors = filteredFloors.filter(floor => floor.property_id === property_id);
        }

        setFloors(getUniqueFloors(filteredFloors));
    }, [property_id]);

    const getUniqueFloors = (floors) => {
        const floorNames = new Set();
        return floors.filter(floor => {
            if (!floorNames.has(floor.floor_id.floor_name)) {
                floorNames.add(floor.floor_id.floor_name);
                return true;
            }
            return false;
        });
    };


    const filteredTenants = tenants.filter((tenant) => {
        if (!searchTenant.trim()) return true;

        const search = searchTenant.trim().toLowerCase();

        const name = (tenant.tenant_store_name || "").toLowerCase();
        const code = (tenant.tenant_code || "").toLowerCase(); // or tenant.tenant_code / tenant_code

        return name.includes(search) || code.includes(search);
    });


    const generateReport = async (e) => {
        e.preventDefault();

        // Validation for start date and end date
        if (endDate < startDate) {
            setValidationMessage('End date cannot be less than start date');
            return;
        } else {
            setValidationMessage('');
        }

        const category_name = category_id !== '' ? categories.find(category => category._id === category_id).category_name : '';
        const property_name = property_id !== '' ? properties.find(property => property._id === property_id).property_name : '';
        const subcategory_name = subcategory_id !== '' ? subcategories.find(subcategory => subcategory._id === subcategory_id).subcategory_name : '';
        const tenant_store_name = tenant_id !== '' ? tenants.find(tenant => tenant._id === tenant_id).tenant_store_name : '';

        const data = {
            concessionaire_id,
            property_access: propertyAccessNames,
            start_date: startDate,
            end_date: endDate,
            group_name,
            category_name,
            property_name,
            subcategory_name,
            // tenant_store_name,
            tenant_id: selectedTenants,
            floor: selectedFloor
        };

        setLoading(true)
        axios
            .post(`${config.hostname}/reports/getitemwisedetailedreport`, data, configheader)
            .then((response) => {
                setReportData(response.data);
                setLoading(false)
                insertToLog(" generated Itemwise report")
                console.log(response.data);
            })
            .catch((error) => {
                toast.error('Error');
                setLoading(false)
                console.log(error);
            });
    };

    const insertToLog = (task) => {
        const data = {
            created_by: login_id,
            concessionaire_id: concessionaire_id,
            module: "Reports",
            task: login_name + task
        }
        axios
            .post(`${config.hostname}/log`, data, configheader)
            .then(() => {
                console.log("inserted to log table")
            })
            .catch((error) => {
                toast.error('Error')
                console.log(error);

            });
    }


    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        setReportData([]);
        setCurrentPage(0);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
        setReportData([]);
        setCurrentPage(0);
    };

    const handleGroupChange = (e) => {
        setGroupName(e.target.value);
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handlePropertyChange = (e) => {
        setPropertyId(e.target.value);
        setTenantId('');
        setSelectedFloor('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handleCategoryChange = (e) => {
        setCategoryId(e.target.value);
        setSubcategoryId('')
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handleSubCategoryChange = (e) => {
        setSubcategoryId(e.target.value);
        setTenantId('')
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    // const handleTenantChange = (e) => {
    //     setTenantId(e.target.value);
    //     setReportData([]);
    //     setCurrentPage(0);
    // };


    const handleTenantChange = (e) => {
        const { value, checked } = e.target;

        setSelectedTenants((prev) => {
            if (checked) {
                // Add if not already there
                if (prev.includes(value)) return prev;
                return [...prev, value];
            } else {
                // Remove if unchecked
                return prev.filter((item) => item !== value);
            }
        });

        setReportData([]);
        setCurrentPage(0);
    };


    const handleFloorChange = (e) => {
        setSelectedFloor(e.target.value);
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    //const offset = currentPage * itemsPerPage;
    const pageCount = Math.ceil(ReportData.length / itemsPerPage);

    //const totalTransactionCount = ReportData.reduce((sum, item) => sum + item.transaction_count, 0);
    // const totalNetSales = ReportData.reduce((sum, item) => sum + item.net_sales, 0);
    // const totalGrossAmount = ReportData.reduce((sum, item) => sum + item.gross_amount, 0);

    const dailySalesMap = new Map();

    ReportData.forEach((row) => {
        const key = `${row.transaction_date}__${row.tenant_store_name}__${row.outlet_code}__${row.property_name}`;

        if (!dailySalesMap.has(key)) {
            dailySalesMap.set(key, {
                net_sales: Number(row.net_sales) || 0,
                gross_amount: Number(row.gross_amount) || 0,
            });
        }
    });

    // const totalNetSales = Array.from(dailySalesMap.values()).reduce((sum, v) => sum + v.net_sales, 0);
    // const totalGrossAmount = Array.from(dailySalesMap.values()).reduce((sum, v) => sum + v.gross_amount, 0);

    const totalItemQty = ReportData.reduce((sum, item) => sum + item.item_quantity, 0);
    const totalItemUnitPrice = ReportData.reduce((sum, item) => sum + item.item_unit_price, 0);
    const totalItemTotalPrice = ReportData.reduce((sum, item) => sum + item.item_total_price, 0);
    const totalItemNetSale = ReportData.reduce((sum, item) => sum + item.item_netsale_without_vat, 0);
    const totalItemDiscount = ReportData.reduce((sum, item) => sum + item.item_discount, 0);
    const totalItemGrossAmount = ReportData.reduce((sum, item) => sum + Number(item.item_gross_amount || 0), 0);
    const totalItemTaxAmount = ReportData.reduce((sum, item) => sum + Number(item.item_tax_amount || 0), 0);

    const sortedReportData = React.useMemo(() => {
        let sortableData = [...ReportData];
        if (sortConfig.key !== '') {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [ReportData, sortConfig]);

    const currentPageData = sortedReportData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    // const selectedCols = React.useMemo(() => {
    //   let cols = [];

    //   ALL_COLUMNS.forEach(col => {
    //     if (!selectedColumns.includes(col.key)) return;

    //     // Special handling for payment
    //     if (col.key === 'payment_details') {
    //       cols.push(...getPaymentColumns(ReportData));
    //     } else {
    //       cols.push(col);
    //     }
    //   });

    //   return cols;
    // }, [selectedColumns, ReportData]);

    const selectedCols = React.useMemo(() => {
        return ALL_COLUMNS.filter(col => selectedColumns.includes(col.key));
    }, [selectedColumns]);

    const formatCell = (col, value) => {
        if (col.isMoney) {
            return value
                ? Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : '0.00';
        }
        return value ?? '';
    };

    const totalsByKey = {
        // net_sales: totalNetSales,
        // gross_amount: totalGrossAmount,
        item_quantity: totalItemQty,
        item_unit_price: totalItemUnitPrice,
        item_discount: totalItemDiscount,
        item_total_price: totalItemTotalPrice,
        item_netsale_without_vat: totalItemNetSale,
        item_gross_amount: totalItemGrossAmount,
        item_tax_amount: totalItemTaxAmount,
    };

    const getSortIcon = key => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === 'asc') {
                return <FontAwesomeIcon icon={faSortUp} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
            if (sortConfig.direction === 'desc') {
                return <FontAwesomeIcon icon={faSortDown} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
        }

    };

    const handleExport = (format) => {
        if (ReportData.length > 0) {
            if (format === 'excel') {
                exportToExcel();
                insertToLog(" exported Itemwise report to excel");
            } else if (format === 'pdf') {
                exportToPDF();
                insertToLog(" exported Itemwise report to pdf")
            }
        }
    };


    const exportToExcel = () => {

        // Build export rows based on selected columns (label as header)
        const exportData = ReportData.map(item => {
            const row = {};
            selectedCols.forEach(col => {
                // keep numbers as numbers for excel formatting
                if (col.isMoney || col.key === 'item_quantity') {
                    row[col.label] = Number(item[col.key] || 0);
                } else {
                    row[col.label] = item[col.key] ?? '';
                }
            });
            return row;
        });

        const worksheet = XLSX.utils.aoa_to_sheet([[]]);

        // Title
        XLSX.utils.sheet_add_aoa(worksheet, [['Itemwise Detailed Report']], { origin: 'A1' });
        worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: Math.max(selectedCols.length - 1, 0) } }];

        // Metadata (unchanged)
        const dateDisplay = startDate === endDate
            ? [['Date', startDate]]
            : [['From', startDate], ['To', endDate]];

        const metadata = [
            ...dateDisplay,
            ['Property', property_id ? properties.find(p => p._id === property_id)?.property_name : 'All'],
            ['Category', category_id ? categories.find(c => c._id === category_id)?.category_name : 'All'],
            ['Group', group_name || 'All'],
            ['Subcategory', subcategory_id ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name : 'All'],
            ['Floor', selectedFloor || 'All'],
            ['Exported By', login_name],
            ['Exported On', new Date().toLocaleString()]
        ];

        XLSX.utils.sheet_add_aoa(worksheet, metadata, { origin: 'A2' });

        // Headers row
        const startRow = metadata.length + 3;

        const headers = [selectedCols.map(c => c.label)];
        XLSX.utils.sheet_add_aoa(worksheet, headers, { origin: `A${startRow - 1}` });

        // Data rows
        XLSX.utils.sheet_add_json(worksheet, exportData, {
            origin: `A${startRow}`,
            skipHeader: true
        });

        // Total row
        const totalRowIndex = startRow + exportData.length;

        const totalRow = selectedCols.map((col, idx) => {
            if (idx === 0) return 'TOTAL';
            if (totalsByKey[col.key] !== undefined) return Number(totalsByKey[col.key] || 0);
            return '';
        });

        XLSX.utils.sheet_add_aoa(worksheet, [totalRow], { origin: `A${totalRowIndex + 1}` });

        // Number formatting (money + qty)
        const moneyKeys = new Set([
            'item_unit_price',
            'item_discount',
            'item_total_price',
            'item_netsale_without_vat',
            'item_gross_amount',
            'item_tax_amount'
        ]);
        const qtyKeys = new Set(['item_quantity']);

        const moneyColIndexes = selectedCols
            .map((c, i) => (moneyKeys.has(c.key) ? i : -1))
            .filter(i => i >= 0);

        const qtyColIndexes = selectedCols
            .map((c, i) => (qtyKeys.has(c.key) ? i : -1))
            .filter(i => i >= 0);

        for (let r = startRow; r <= totalRowIndex + 1; r++) {
            moneyColIndexes.forEach(c => {
                const cell = XLSX.utils.encode_cell({ r: r - 1, c });
                if (worksheet[cell]) {
                    worksheet[cell].t = 'n';
                    worksheet[cell].z = '#,##0.00';
                }
            });

            qtyColIndexes.forEach(c => {
                const cell = XLSX.utils.encode_cell({ r: r - 1, c });
                if (worksheet[cell]) {
                    worksheet[cell].t = 'n';
                    worksheet[cell].z = '#,##0';
                }
            });
        }

        // Column widths
        worksheet['!cols'] = selectedCols.map(() => ({ wch: 18 }));

        // Export file
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
        XLSX.writeFile(workbook, 'ItemwiseReport.xlsx');
    };


    const exportToPDF = () => {
        const doc = new jsPDF('l', 'pt', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Title
        doc.setFontSize(13);
        doc.setFont('helvetica', 'bold');
        doc.text('Itemwise Detailed Report', pageWidth / 2, 20, { align: 'center' });

        // Metadata
        doc.setFontSize(7);
        doc.setFont('helvetica', 'normal');

        const meta = [
            startDate === endDate ? `Date: ${startDate}` : `From: ${startDate} To: ${endDate}`,
            `Property: ${property_id ? properties.find(p => p._id === property_id)?.property_name : 'All'}`,
            `Category: ${category_id ? categories.find(c => c._id === category_id)?.category_name : 'All'}`,
            `Group: ${group_name || 'All'}`,
            `Subcategory: ${subcategory_id ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name : 'All'}`,
            `Floor: ${selectedFloor || 'All'}`,
            `Exported By: ${login_name}`,
            `Exported On: ${new Date().toLocaleString()}`
        ];

        let startY = 40;
        meta.forEach(t => {
            doc.text(t, 20, startY);
            startY += 10;
        });
        startY += 10;

        const fmt2 = (v) =>
            Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        // Dynamic Head
        const headRow = selectedCols.map(c => c.label);

        // Dynamic Body
        const bodyRows = ReportData.map(item => (
            selectedCols.map(col => {
                if (col.isMoney) return fmt2(item[col.key]);
                if (col.key === 'item_quantity') return Number(item[col.key] || 0).toLocaleString();
                return item[col.key] ?? '';
            })
        ));

        // Dynamic Footer totals row
        const footRow = selectedCols.map((col, idx) => {
            if (idx === 0) return 'TOTAL';
            if (totalsByKey[col.key] !== undefined) {
                if (col.isMoney) return fmt2(totalsByKey[col.key]);
                if (col.key === 'item_quantity') return Number(totalsByKey[col.key] || 0).toLocaleString();
                return totalsByKey[col.key];
            }
            return '';
        });

        doc.autoTable({
            startY,
            theme: 'grid',
            head: [headRow],
            body: bodyRows,
            foot: [footRow],
            showFoot: 'lastPage',

            styles: { fontSize: 6, cellPadding: 3 },
            headStyles: { fillColor: [0, 71, 178], textColor: 255, fontSize: 6 },
            footStyles: { fillColor: [0, 71, 178], textColor: 255, fontStyle: 'bold', fontSize: 7 },

            margin: { left: 10, right: 10 },
            pageBreak: 'auto'
        });

        // Page numbers
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(7);
            doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 20, { align: 'center' });
        }

        doc.save('ItemwiseReport.pdf', { compress: true });
    };

    const reset = () => {
        setStartDate('')
        setEndDate('')
        setPropertyId('');
        setCategoryId('');
        setSubcategoryId('');
        setGroupName('');
        setTenantId('');
        setSelectedFloor('');
        setSelectedTenants([]);
        setSearchTenant('');
        setDropdownOpen(false);
        setReportData([])
    }

    return (
        <Fragment>
            <Form className='theme-form' onSubmit={generateReport}>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="startdate">Start Date</Label>
                                    <input className="form-control digits"
                                        id="startdate" type="date" name="startdate" value={startDate}
                                        max={today} onChange={handleStartDateChange} required />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="enddate">End Date</Label>
                                    <input className="form-control digits"
                                        id="startdate" type="date" name="startdate" value={endDate}
                                        max={today} onChange={handleEndDateChange} required />
                                </FormGroup>
                                {validationMessage && (
                                    <span className="text-danger">{validationMessage}</span>
                                )}
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="property_id">Property</Label>
                                    <select name="property_id" id="property_id" className="form-control"
                                        value={property_id} onChange={handlePropertyChange}>
                                        <option value="">All</option>
                                        {properties.map(property => (
                                            <option key={property._id} value={property._id}>{property.property_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="tenant_id">Floor</Label>
                                    <select name="tenant_id" id="tenant_id" className="form-control"
                                        value={selectedFloor} onChange={handleFloorChange}>
                                        <option value="">All</option>
                                        {floors.map((floor, index) => (
                                            <option key={index} value={floor.floor_id.floor_name}>{floor.floor_id.floor_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="category_id">Category</Label>
                                    <select name="category_id" id="category_id" className="form-control"
                                        value={category_id} onChange={handleCategoryChange}>
                                        <option value="">All</option>
                                        {categories.map(category => (
                                            <option key={category._id} value={category._id}>{category.category_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Sub Category</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={subcategory_id} onChange={handleSubCategoryChange}>
                                        <option value="">All</option>
                                        {subcategories.map(subcategory => (
                                            <option key={subcategory._id} value={subcategory._id}>{subcategory.subcategory_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Group</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={group_name} onChange={handleGroupChange}>
                                        <option value="">All</option>
                                        {groups.map((group, index) => (
                                            <option key={index} value={group}>{group}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            {/* <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="tenant_id">Tenant</Label>
                                    <select name="tenant_id" id="tenant_id" className="form-control"
                                        value={tenant_id} onChange={handleTenantChange}>
                                        <option value="">All</option>
                                        {tenants.map(tenant => (
                                            <option key={tenant._id} value={tenant._id}>{tenant.tenant_store_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col> */}

                            <Col>
                                <div style={{ position: 'relative', width: '100%' }} ref={dropdownRef}>
                                    <label>Tenants</label>
                                    <div
                                        onClick={toggleDropdown}
                                        style={{
                                            border: '1px solid #ccc',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div>Select Tenants</div>
                                        <span style={{ marginLeft: 'auto' }}>&#9662;</span>
                                    </div>
                                    {dropdownOpen && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                backgroundColor: '#fff',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                marginTop: '4px',
                                                zIndex: 1,
                                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '250px', // Set the maximum height for the dropdown
                                                overflowY: 'auto' // Scrollable content
                                            }}
                                        >
                                            {/* Search Bar */}
                                            <div style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search tenants..."
                                                    value={searchTenant}
                                                    onChange={(e) => setSearchTenant(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '6px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>

                                            {/* Filtered Tenants List */}
                                            {filteredTenants.length > 0 ? (
                                                filteredTenants.map(tenant => (
                                                    <label
                                                        key={tenant._id}
                                                        style={{ display: 'block', padding: '8px', cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            value={tenant._id}
                                                            checked={selectedTenants.includes(tenant._id)}
                                                            onChange={handleTenantChange}
                                                            style={{ marginRight: '8px' }}
                                                        />

                                                        {/* 👇 Display code + name */}
                                                        <span style={{ fontWeight: 500 }}>
                                                            {tenant.tenant_store_name}
                                                            {tenant.tenant_code ? ` - ${tenant.tenant_code}` : ""}
                                                        </span>
                                                    </label>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: 'gray', textAlign: 'center' }}>
                                                    No results found
                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            </Col>

                        </Row>
                        <Row>
                            <Col >
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', type: "submit" }} >Generate Report</Btn>
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: reset }} >Reset</Btn>
                            </Col>

                        </Row>


                    </CardBody>
                </Card>
            </Form>
            {loading === true ? (
                <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-3' }} />
                </div>

            ) : (
                <Card>
                    <CardHeader>
                        <Row className="justify-content-end">
                            <Col xs="auto">
                                <div ref={columnDropdownRef} style={{ position: 'relative' }}>

                                    {/* Button */}
                                    <Btn
                                        attrBtn={{
                                            color: 'primary',
                                            type: 'button',
                                            onClick: () => setColumnDropdownOpen(v => !v),
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }
                                        }}
                                    >
                                        Columns
                                        <span style={{ fontSize: 10 }}>▼</span>
                                    </Btn>

                                    {/* Popover */}
                                    {columnDropdownOpen && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '110%',
                                                right: 0,
                                                width: 280,
                                                background: '#fff',
                                                border: '1px solid #ddd',
                                                borderRadius: 8,
                                                boxShadow: '0 6px 18px rgba(0,0,0,0.15)',
                                                zIndex: 9999
                                            }}
                                        >

                                            {/* Header */}
                                            <div style={{
                                                padding: '10px 12px',
                                                borderBottom: '1px solid #eee',
                                                fontWeight: 600
                                            }}>
                                                Choose Columns
                                            </div>

                                            {/* Select all */}
                                            <label style={{ display: 'flex', gap: 8, padding: 10, cursor: 'pointer' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedColumns.length === ALL_COLUMNS.length}
                                                    onChange={(e) =>
                                                        setSelectedColumns(e.target.checked
                                                            ? ALL_COLUMNS.map(c => c.key)
                                                            : [])
                                                    }
                                                />
                                                Select All
                                            </label>

                                            {/* Scrollable list */}
                                            <div style={{ maxHeight: 260, overflowY: 'auto' }}>
                                                {ALL_COLUMNS.map(col => (
                                                    <label
                                                        key={col.key}
                                                        style={{
                                                            display: 'flex',
                                                            gap: 8,
                                                            padding: '8px 12px',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedColumns.includes(col.key)}
                                                            onChange={() =>
                                                                setSelectedColumns(prev =>
                                                                    prev.includes(col.key)
                                                                        ? prev.filter(k => k !== col.key)
                                                                        : [...prev, col.key]
                                                                )
                                                            }
                                                        />
                                                        {col.label}
                                                    </label>
                                                ))}
                                            </div>

                                        </div>
                                    )}

                                </div>
                            </Col>

                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('excel'),
                                        onMouseEnter: () => handleMouseEnter('Export to Excel'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileExcel} size="lg" />
                                </Btn>
                                {tooltip === 'Export to Excel' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col>
                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('pdf'),
                                        onMouseEnter: () => handleMouseEnter('Export to PDF'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFilePdf} size="lg" />
                                </Btn>
                                {tooltip === 'Export to PDF' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Col sm="12" lg="12" xl="12">
                            <div className="table-responsive" >
                                <Table>
                                    {/* 🔹 Control column widths ONLY for tenant details */}
                                    <colgroup>
                                        {selectedCols.map(col => {
                                            if (col.key === 'tenant_store_name') {
                                                return <col key={col.key} style={{ width: '250px' }} />;
                                            }
                                            if (col.key === 'group_name') {
                                                return <col key={col.key} style={{ width: '250px' }} />;
                                            }
                                            if (col.key === 'tenant_code') {
                                                return <col key={col.key} style={{ width: '120px' }} />;
                                            }
                                            if (col.key === 'outlet_code') {
                                                return <col key={col.key} style={{ width: '120px' }} />;
                                            }
                                            if (col.key === 'property_name') {
                                                return <col key={col.key} style={{ width: '220px' }} />;
                                            }
                                            if (col.key === 'subcategory_name') {
                                                return <col key={col.key} style={{ width: '220px' }} />;
                                            }
                                            if (col.key === 'transaction_date') {
                                                return <col key={col.key} style={{ width: '120px' }} />;
                                            }
                                            if (col.key === 'invoice_no') {
                                                return <col key={col.key} style={{ width: '150px' }} />;
                                            }

                                            if (col.key === 'sku') {
                                                return <col key={col.key} style={{ width: '250px' }} />;
                                            }

                                            if (col.key === 'item_name') {
                                                return <col key={col.key} style={{ width: '250px' }} />;
                                            }
                                            return <col key={col.key} />;
                                        })}
                                    </colgroup>

                                    <thead>
                                        <tr>
                                            {selectedCols.map(col => (
                                                <th
                                                    key={col.key}
                                                    scope="col"
                                                    onClick={() => requestSort(col.key)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        whiteSpace: ['tenant_store_name', 'group_name', 'tenant_code', 'outlet_code', 'property_name', 'subcategory_name', 'transaction_date', 'invoice_no', 'sku', 'item_name']
                                                            .includes(col.key)
                                                            ? 'nowrap'
                                                            : 'normal'
                                                    }}
                                                >
                                                    {col.label} {getSortIcon(col.key)}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentPageData.map((item, index) => (
                                            <tr key={index}>
                                                {selectedCols.map(col => (
                                                    <td
                                                        key={col.key}
                                                        style={{
                                                            whiteSpace: ['tenant_store_name', 'group_name', 'tenant_code', 'outlet_code', 'property_name', 'subcategory_name', 'transaction_date', 'invoice_no', 'sku', 'item_name']
                                                                .includes(col.key)
                                                                ? 'nowrap'
                                                                : 'normal'
                                                        }}
                                                        title={item[col.key]}   // 👈 hover to see full value
                                                    >
                                                        {formatCell(col, item[col.key])}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            {selectedCols.map((col, idx) => {
                                                if (idx === 0) return <td key={col.key}>Total</td>;

                                                if (totalsByKey[col.key] !== undefined) {
                                                    const val = totalsByKey[col.key];
                                                    return (
                                                        <td key={col.key}>
                                                            {col.isMoney
                                                                ? Number(val || 0).toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                                : Number(val || 0).toLocaleString()}
                                                        </td>
                                                    );
                                                }

                                                return <td key={col.key}></td>;
                                            })}
                                        </tr>
                                    </tfoot>
                                </Table>
                            </div>
                            {ReportData.length > 50 && (
                                <ReactPaginate
                                    previousLabel={'<<'}
                                    nextLabel={'>>'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                />
                            )}
                        </Col>
                    </CardBody>
                </Card>
            )}
        </Fragment>
    );
};

export default ItemwiseReportView;